var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[(_vm.title)?_c('h2',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('Tooltip',{attrs:{"position":"bottom","step":_vm.tooltipStep}},[_c('div',{ref:"tabs",staticClass:"tabs"},[_c('div',{staticClass:"tabs-inner"},[_vm._t("default"),_c('span',{ref:"activeBg",class:[
            'active-bg',
            !_vm.useTransitionForActiveBg ? 'active-bg--no-transition' : ''
          ]})],2)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }